export default {
  open: 'Historique des modifications',
  title: 'Historique des modifications',
  close: 'Fermer l’historique',
  period: 'Période',
  periods: {
    all: 'Toutes les dates',
    week: '7 derniers jours',
    month: '30 derniers jours',
  },
  author: 'Utilisateur',
  allAuthors: 'Tous les utilisateurs',
  region: 'Région',
  allRegions: 'Toutes les régions',
  vertical: 'Verticale',
  allVerticals: 'Toutes les verticales',
  emptyTitle: 'Aucune modification pour le moment',
  emptyText: 'Les changements enregistrés dans ce module apparaîtront ici.',
  noResultTitle: 'Aucun résultat',
  noResultText: 'Ajustez les filtres pour retrouver une modification.',
  setting: 'Réglage',
  before: 'Avant',
  after: 'Après',
  count: 'Aucune modification | {n} modification | {n} modifications',
  more: 'Charger plus',
  sourceApi: 'Toutes les modifications des régions',
  sourceSession: 'Cette session',
  unknownAuthor: 'Utilisateur inconnu',
  lineage: {
    last: 'Dernière modification de la région.',
    loaded: 'Aucune version | {n} version, jusqu’à la création de la région | {n} versions, jusqu’à la création de la région',
    load: 'Charger tout l’historique',
  },
  actions: {
    created: 'Région ajoutée',
    updated: 'Règles modifiées',
    enabled: 'Région activée',
    disabled: 'Région désactivée',
    unknown: 'Modification',
  },
  fields: {
    name: 'Nom',
    description: 'Description',
    departments: 'Départements',
    flux: 'Flux',
    archived: 'État',
    remark: 'Remarque',
  },
};
